module.exports = __webpack_public_path__ + "static/media/img1-1.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/melon/nutricheck_foliar/FE/img1-1.png
// module id = 1840
// module chunks = 3